/* ⚛ REACT */
import { useState, useRef } from "react";

/* 📦 LIBS */
import { useTranslation } from "react-i18next";

/* 📁 ASSETS*/
import { CloseEye, OpenEye } from "../../Assets/icons";

/* 🎨 STYLES */
import { Container, TextInput, InvalidText, ContainerInput, ShowButton, ImageIcons, Eye, InvalidInfoContainer, InvalidInfo } from "./styles";

const InputPassword = (props) => {
    const [isValid, setIsValid] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [isHover, setIsHover] = useState(false);
    const [color, setColor] = useState('#C7C7C7');
    const value = useRef('');
    const { t } = useTranslation(); 

    function ApplyHover (){
        setIsHover(true)
        color !== '#006560' && color !== '#FF3939' ? setColor('#A3A3A3') : setColor(color);
    }

    function ApplyBlur(){
        setIsHover(false)
        color !== '#006560' && color !== '#FF3939' ? setColor('#C7C7C7') : setColor(color);
    }

    return(
        <Container>
            <ContainerInput $isvalid={isValid} $borderColor={color} onMouseOver={()=>ApplyHover()} onMouseOut={()=>ApplyBlur()}>
                {props.icon ? <ImageIcons src={props.icon} color={color}/> : <></>}
                <TextInput
                    type= {showPassword ? 'text' : 'password'}
                    name={props.name}
                    id={props.id} 
                    ref={props.innerRef}
                    placeholder = {props.placeholder}
                    autoComplete= "on"
                    onChange={(e)=> {
                        if(props.innerRef.current.focused || !isValid){
                            setIsValid(props.validationFunction(e.target.value))
                            props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                        }
                        props.onchange(e.target.value)
                        value.current = e.target.value;
                    }}
                    onFocus={(e)=> {
                        props.onchange(e.target.value)
                        color !== '#FF3939' ? setColor('#006560') : setColor(color)}}
                    onBlur={(e)=> {
                        props.onchange(e.target.value)
                        setIsValid(props.validationFunction(e.target.value))
                        props.validationFunction(e.target.value) ? setColor('#006560') : setColor('#FF3939');
                    }}
                    $isvalid={isValid}>
                </TextInput>
                <ShowButton onClick={()=> setShowPassword(!showPassword)}>
                    <Eye src={showPassword ? OpenEye : CloseEye} color={color}/>
                </ShowButton>
            </ContainerInput>
            {!isValid && isHover ? 
                <InvalidInfoContainer onMouseOver={()=>ApplyHover()} onMouseOut={()=>ApplyBlur()}>
                    <InvalidInfo>{t("login.password.pattern-message")}</InvalidInfo>
                </InvalidInfoContainer>
            : null}
            <InvalidText $visibility={isValid}>{props.invalidMessage}</InvalidText>
        </Container>
    )
}

export default InputPassword;